export interface FoodItem {
  id: string;
  name: string;
  store: string;
  image: string;
  price: string | number;
  banner: boolean;
  banner_order?: number;
  enabled: boolean;
  order?: number;
  restaurantId: string;
  food_enabled?: boolean;
  /** Pre-order switch from Menu Management; only used to disable row when on Pre-order tab */
  enabled_pre_order?: boolean;
}

export enum MenuType {
  REGULAR_ORDERS = 'regular_order',
  SPECIAL_ORDERS = 'special_order',
  REGULAR_PRE_ORDERS = 'regular_pre_order',
  SPECIAL_PRE_ORDERS = 'special_pre_order',
}

export interface FoodCategoryStatus {
  id: string;
  banner: boolean;
  enabled: boolean;
  order?: number;
  recommended_food_ids?: RecommendedFoodMeta[];
}

export interface RecommendedFoodMeta {
  enabled: boolean;
  order: number;
  recommended_food_id: string;
  food_enabled?: boolean;
}

export interface UserMenuRecommendedFood {
  id: string;
  enabled: boolean;
  order: number;
}

export interface UserMenuFoodItem {
  id: string;
  banner: boolean;
  banner_order?: number;
  enabled: boolean;
  order: number;
  recommended_food?: UserMenuRecommendedFood[];
}

export interface UserMenuCategory {
  id: string;
  food_ids?: UserMenuFoodItem[];
  order: number;
}

export interface UserMenuListData {
  categories?: UserMenuCategory[];
}

export interface Food {
  id: string;
  name?: string;
  food_name?: string;
  description?: string;
  image_url: string | string[];
  sku: string;
  price: string | number;
  tax_rate: string;
  categories?: string[];
  categories_menu_ids?: string[];
  min_quantity_per_order?: number;
  max_quantity_per_order?: number;
  foods?: string[];
  banner?: boolean;
  banner_order?: number;
  enabled?: boolean;
  order?: number;
  recommended_food?: RecommendedFoodMeta[];
  restaurantId?: string;
  restaurantName?: string;
  food_enabled?: boolean;
  enabled_pre_order?: boolean;
  sold?: number;
}

export const ITEM_TYPE = 'FOOD_ROW';
export const RECOMMENDATION_TYPE = 'RECOMMENDATION';
